export default "__VITE_ASSET__BvOBieQH__";